import React from "react";
import { DEFAULT_AREA_RADIUS } from "./constants";

/**
 * @typedef {Object} Point
 * @property {number} lat
 * @property {number} lng
 */

/**
 * @typedef {"radius" | "path"} Mode
 */

/**
 * @typedef {Object} Voice
 * @property {string} id
 * @property {string} name
 * @property {string} provider
 * @property {string} sample
 */

/**
 * @typedef {Object} OnDemandContextType
 * Values
 * @property {Mode} mode
 * @property {Point | null} startingPoint
 * @property {Point | null} endingPoint
 * @property {number} areaRadius
 * @property {string} selectedLanguage
 * @property {Voice | null} selectedVoice
 * @property {string[]} selectedPlaces
 * Methods
 * @property {(mode: Mode) => void} changeMode
 * @property {(point: Point) => void} changeStartingPoint
 * @property {(point: Point) => void} changeEndingPoint
 * @property {(radius: number) => void} changeAreaRadius
 * @property {(langCode: string | null) => void} changeSelectedLanguage
 * @property {(voice: Voice | null) => void} changeSelectedVoice
 * @property {(method: Method | null) => void} changeSelectedMethod
 * @property {(placeIds: ) => void} changeSelectedPlaces
 * @property {(startingPoint?: Point) => void} resetTourGeography
 */

/** @type {OnDemandContextType} */
const initalState = {
  mode: "radius",
  startingPoint: null,
  endingPoint: null,
  areaRadius: DEFAULT_AREA_RADIUS,
  selectedLanguage: null,
  selectedPlaces: [],
  changeMode: () => undefined,
  startingPointChange: () => undefined,
  endingPointChange: () => undefined,
  changeAreaRadius: () => undefined,
  changeSelectedVoice: () => undefined,
  changeSelectedMethod: () => undefined,
  changeSelectedPlaces: () => undefined,
  resetTourGeography: () => undefined,
};

export const OnDemandContext = React.createContext(initalState);
